import { adaptPendingFeedbackList, type PendingFeedbackList } from '@tempmee/awards';
import * as Client from '../clients/GetPendingBidFeedback';

/**
 * Pending BID feedback for the Today's-Shift tab and the EOD cycle
 * resolution (awards-service #37, GOTU-6281/GOTU-6571). Envelope unwrapping
 * lives in `@tempmee/awards`; an empty `cycleId` means no cycle is accepting
 * and pending-feedback UI must not render.
 */
export const getPendingBidFeedbackService = async (): Promise<PendingFeedbackList> => {
  const response = await Client.getPendingBidFeedback();
  return adaptPendingFeedbackList(response);
};
